<template>
  <section class="help-wrapper">
    <h3 class="help-title text-center">资料下载</h3>
    <ul class="file-down-list">
      <li v-for="file in downloadList" :key="file.fileId">
        <div class="file-group">
          <div class="file-inner">
            <img class="file-icon" :src="fileIcon" />
            <span>{{ file.fileName }}</span>
          </div>
          <div class="file-append">立即下载</div>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Help', // 帮助中心
  data() {
    return {
      downloadList: [
        {
          fileName: '操作手册',
          fileId: '1',
        },
        {
          fileName: '常见问题清单',
          fileId: '2',
        },
        {
          fileName: '保函格式',
          fileId: '3',
        },
        {
          fileName: '履约保函资料清单',
          fileId: '4',
        },
      ],
      fileIcon: require('@/assets/pdf.png'),
    }
  },
}
</script>

<style scoped lang="less">
.help-wrapper {
  padding-top: 20px;
  background-color: #ffffff;
}
.help-title {
  padding: 20px;
  font-size: 20px;
  color: #333;
}
.file-down-list {
  width: 772px;
  margin: 0 auto;
}
.file-group {
  width: 772px;
  height: 50px;
  display: inline-table;
  margin-bottom: 20px;
}
.file-inner {
  vertical-align: middle;
  display: table-cell;
  border: 1px solid #e4e4e4;
  border-right: none;
  padding: 0 20px;
  span {
    vertical-align: middle;
    display: inline-block;
  }
  img {
    vertical-align: middle;
    display: inline-block;
  }
}
.file-append {
  background-color: #3b85f4;
  color: #fff;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  padding: 0 20px;
  width: 96px;
  white-space: nowrap;
  cursor: pointer;
}
.file-append:active {
  opacity: 0.75;
}
.file-icon {
  height: 30px;
  margin-right: 10px;
}
</style>
